import { RouteConfig } from 'vue-router';
import store from '@/store';

export const NAME_ROUTES_HISTORIC = {
  PAYMENT: 'Historic'
};

export const Historic: Array<RouteConfig> = [
  {
    path: '/historico',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_HISTORIC.PAYMENT,
        component: () => import(
          /* webpackChunkName: "historicPayment" */ '@/pages/HistoricPayment/HistoricPayment.vue'
        ),
        beforeEnter: (to, from, next) => {
          const { profile } = store.getters;
          const hasInstitution = !!profile?.institution?.id;

          if (hasInstitution) {
            next({ name: 'Dashboard' });
          } else {
            next();
          }
        },
        meta: { title: 'Histórico de pagamentos' }
      }
    ]
  }
];
